export enum Locale {
  EnUS = 'en-US',
}
